module.exports = __webpack_public_path__ + "static/media/998156.e9cbb71c.jpg";